<template>
    <b-nav-item-dropdown
        v-if="
            _hasAccess('patient.profile.create') ||
            _hasAccess('patient.record.create') ||
            _hasAccess('client.profile.create') ||
            _hasAccess('inventory.item.create') ||
            _hasAccess('billing.estimate.create') ||
            _hasAccess('billing.invoice.create') ||
            _hasAccess('billing.payment.create')
        "
        data-top-right-id="shortcuts"
        id="nav-item-shortcut"
        no-caret
        right
    >
        <template slot="button-content">
            <!-- <i class="famfamfam-silk add"></i> -->
            <i class="fas fa-plus-circle" style="color: #97d14f;"></i>
            <span class="d-lg-none">Quick Add</span>
        </template>

        <b-dropdown-item
            v-if="
                _hasAccess('patient.profile.create') &&
                _.get(subscription, 'is_patient_count')
            "
            @click="displaySubscription"
            data-top-shortcut-id="new-patient"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Patient
        </b-dropdown-item>
        <b-dropdown-item
            v-else-if="_hasAccess('patient.profile.create')"
            @click="createNewPatient"
            data-top-shortcut-id="new-patient"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Patient
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('patient.record.create')"
            @click.stop="createMedicalNote()"
            data-top-shortcut-id="new-medical-note"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Medical Note
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('client.profile.create')"
            href="/view/client/new"
            @click.prevent="goToNewClientPage"
            data-top-shortcut-id="new-client"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Client
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('inventory.item.create')"
            href="/view/inventory/item-new"
            @click.prevent="goToNewInventoryItemPage"
            data-top-shortcut-id="new-inventory-item"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Inventory Item
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('billing.estimate.create')"
            @click.stop="createEstimate()"
            data-top-shortcut-id="new-estimate"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Estimate
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('billing.invoice.create')"
            @click.stop="createInvoice()"
            data-top-shortcut-id="new-invoice"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Invoice
        </b-dropdown-item>

        <b-dropdown-item
            v-if="_hasAccess('billing.payment.create')"
            @click.stop="createPayment()"
            data-top-shortcut-id="new-payment"
        >
            <i class="fas fa-plus-circle quick-add"></i>
            New Payment
        </b-dropdown-item>

        <b-container fluid>
            <createMedicalNote ref="createMedicalNoteWindow" />
        </b-container>
        <b-container fluid>
            <createEstimate ref="createEstimateWindow" />
        </b-container>
        <b-container fluid>
            <createInvoice ref="createInvoiceWindow" />
        </b-container>
        <b-container fluid>
            <createPayment ref="createPaymentWindow" />
        </b-container>
        <b-container fluid>
            <new-patient-modal
                show-add-new
                enable-record-sharing
                ref="newPatientModal"
                @saved="newPatientSaved"
            />
        </b-container>
    </b-nav-item-dropdown>
</template>

<style lang="scss" scoped>
#nav-item-shortcut {
    .fas.quick-add {
        margin-right: 3px;
        color: #678f35;
    }
}
</style>

<script>
import CreateMedicalNote from "../soap/create.vue";
import CreateEstimate from "@/components/client-estimates/estimate-new-modal.vue";
import CreateInvoice from "@/components/new-invoice/invoice-modal";
import CreatePayment from "@/components/new-payment/payment-modal.vue";
import NewPatientModal from "@/module/commons/patient/modal.vue";

export default {
    components: {
        CreateMedicalNote,
        CreateEstimate,
        CreateInvoice,
        CreatePayment,
        NewPatientModal
    },
    data() {
        return {
            subscription: null,
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true"
        };
    },
    mounted() {
        this._getSubscription().then(data => {
            this.subscription = data;
        });
    },
    methods: {
        createMedicalNote() {
            this.$refs.createMedicalNoteWindow.open();
        },
        createEstimate() {
            this.$refs.createEstimateWindow.open();
        },
        createInvoice() {
            this.$refs.createInvoiceWindow.open();
        },
        createPayment() {
            this.$refs.createPaymentWindow.open();
        },
        displaySubscription() {
            this.$root.$emit("display-subscription");
        },
        goToNewClientPage() {
            this.$router.push("/client/new");
        },
        goToNewInventoryItemPage() {
            this.$router.push("/inventory/item-new");
        },
        createNewPatient() {
            this.$refs.newPatientModal.open();
        },
        newPatientSaved(patient) {
            this.$router.push({
                name: "patient_profile",
                params: { id: patient.encoded_id || patient.encodedId }
            });
        }
    }
};
</script>
